import React from "react";
import DashboardView from "../views/DashboardView";

export function renderDashboardMenuContent({
    students,
    schedules,
    finances,
    annualBudget,
    setActiveMenu,
    addItem,
    updateItem,
    deleteItem,
    userProfile,
    meetingMinutes,
    visitLogs,
    isDashboardSettingsOpen,
    setIsDashboardSettingsOpen,
    isAaronOpen,
    selectedDepartment,
    myDepartments,
    handleUpdateMyDepartments,
    currentTheme,
    chatHistory,
    setChatHistory,
    earnedBadges,
    level,
    levelProgress,
    totalPoints,
    setIsProfileModalOpen,
    setTargetStatisticsSection,
    setStudentListType,
    setTargetStudentId,
    setDetailReturnMenu
}) {
    const handleOpenStudentDetailFromRecommendation = (studentId) => {
        if (!studentId) return;
        setDetailReturnMenu("dashboard");
        setStudentListType("student");
        setTargetStudentId(studentId);
        setActiveMenu("students");
    };

    return (
        <DashboardView
            students={students}
            schedules={schedules}
            finances={finances}
            annualBudget={annualBudget}
            onNavigate={setActiveMenu}
            onAdd={(d) => addItem("schedules", d)}
            onUpdate={(d) => updateItem("schedules", d.id, d)}
            onDelete={(id) => deleteItem("schedules", id)}
            userProfile={userProfile}
            meetingMinutes={meetingMinutes}
            visitLogs={visitLogs}
            isSettingsOpen={isDashboardSettingsOpen}
            onToggleSettings={() => setIsDashboardSettingsOpen((prev) => !prev)}
            onCloseSettings={() => setIsDashboardSettingsOpen(false)}
            isAaronOpen={isAaronOpen}
            selectedDepartment={selectedDepartment}
            myDepartments={myDepartments}
            onUpdateMyDepartments={handleUpdateMyDepartments}
            theme={currentTheme}
            chatHistory={chatHistory}
            setChatHistory={setChatHistory}
            onOpenAaronWidget={() => setActiveMenu("ai-assistant")}
            earnedBadges={earnedBadges}
            level={level}
            levelProgress={levelProgress}
            totalPoints={totalPoints}
            onOpenProfile={() => setIsProfileModalOpen(true)}
            onNavigateToStatisticsSection={(sectionId) => {
                setTargetStatisticsSection(sectionId || null);
                setActiveMenu("statistics");
            }}
            onOpenStudentDetailFromRecommendation={handleOpenStudentDetailFromRecommendation}
        />
    );
}

export function renderDefaultDashboardContent({
    students,
    teachers,
    attendanceLogs,
    visitLogs,
    schedules,
    finances,
    annualBudget,
    setActiveMenu,
    selectedDepartment,
    currentTheme,
    userProfile,
    earnedBadges,
    level,
    levelProgress,
    totalPoints,
    setIsProfileModalOpen
}) {
    return (
        <DashboardView
            students={students}
            teachers={teachers}
            attendanceLogs={attendanceLogs}
            visitLogs={visitLogs}
            schedules={schedules}
            finances={finances}
            annualBudget={annualBudget}
            onNavigate={setActiveMenu}
            selectedDepartment={selectedDepartment}
            theme={currentTheme}
            userProfile={userProfile}
            earnedBadges={earnedBadges}
            level={level}
            levelProgress={levelProgress}
            totalPoints={totalPoints}
            onOpenProfile={() => setIsProfileModalOpen(true)}
        />
    );
}
